import { useState } from 'react';

const PowerBiMainProductGroupModel = () => {
  const initialState = {
    id: '',
    powerBiMainProductGroupName: '',
  };

  const [powerBiMainProductGroup, setPowerBiMainProductGroup] =
    useState(initialState);

  return { powerBiMainProductGroup, setPowerBiMainProductGroup, initialState };
};

export default PowerBiMainProductGroupModel;
